import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormState } from '@shared';

import { UserInvitation } from '@account-users/account/models/UserInvitation';
import { UserRoles } from '@account-users/account/models/UserRoles';

@Component({
  selector: 'app-invite-user-form',
  templateUrl: './invite-user-form.component.html',
  styleUrls: ['./invite-user-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InviteUserFormComponent implements OnInit {
  @Input() state: FormState;
  @Input() errorResponse: HttpErrorResponse;
  @Output() inviteUser = new EventEmitter<UserInvitation>();
  public form: FormGroup;
  public formStates = FormState;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      inviteeEmail: this.fb.control('', [
        Validators.required,
        Validators.pattern(/@/i),
        Validators.maxLength(255),
        Validators.email,
      ]),
    });
  }

  get inviteeEmail() {
    return this.form.get('inviteeEmail') as FormControl;
  }

  get errorMessage(): string {
    return this.errorResponse?.status === 409
      ? 'The email is already used on this account. Register an admin email to dismiss this modal'
      : this.errorResponse?.error ?? 'Something went wrong. Please try again.';
  }

  get showAdminNotCreatedMessage() {
    return this.form.status !== 'VALID';
  }

  onSubmit(event: Event) {
    event.preventDefault();
    if (this.form.valid) {
      const userInvitation: UserInvitation = {
        email: (this.inviteeEmail.value as string).toLowerCase(),
        toolsPermissions: [],
        roles: [UserRoles.User],
      };
      this.inviteUser.emit(userInvitation);
    }
  }
}
